module.exports = {
  apiHost: "https://api.thuraya.sensoreal.com.au",
  assetsHost: "https://assets.thuraya.sensoreal.com.au",
  brandName: "Thuraya",
  header: {
    text: { en: "Your Favourite Units" },
    logo:
      "https://static-mbh.sgp1.cdn.digitaloceanspaces.com/nhc/thuraya-favourites-logo.png",
    companyLogo:
      "https://static-mbh.sgp1.cdn.digitaloceanspaces.com/nhc/nhc-favourites-logo.png",
    color: "#fff",
  },
  langs: [
    { code: "en", dir: "ltr" },
    { code: "ar", dir: "rtl" },
  ],
  style: {
    primaryColor: "#98C3C8",
    textColor: "#fff",
  },
  contact: {
    website: "",
    address: "",
    phone: "",
    email: "",
  },
  links: {
    privacy: "",
    youtube:
      "https://www.youtube.com/channel/UCr5L8aVuXBaW58oMU0WaQSQ/featured",
    linkedin: "https://www.linkedin.com/company/national-housing-company-nhc-",
    twitter: "https://twitter.com/saudinhc",
    instagram: "https://www.instagram.com/saudinhc",
    facebook: "",
  },
};
